
const _window: any = window;
export function checkXcx() {
  var env = _window.__wxjs_environment;
  if(env === 'miniprogram'){
    return true;
  }else{
    return false;
  }
}
